<template>
    <router-link v-slot="{ navigate }" custom :to="to" :class="{
        'title': true,
        'is-link': $store.state.settings.enableDashboard}" :title="title" tag="div" >
        <!--  'align-items':topTitle && topTitle.title ? 'end':'center', -->
        <!-- 'margin-top':topTitle && topTitle.title?'24px':'0px' -->
        <div>
            <!-- @click="navigate" -->
            <img v-if="showLogo" :src="logo" class="logo" style="width: 36px;">
            <div v-else style="display: flex;align-items: center;color:#28287D;width: 100%;">
                <svg-icon v-if="topTitle.icon" :name="topTitle.icon" style="font-size: 32px;" />
                <span v-if="topTitle.title"
                    style="font-size:20px;color:#28287D;">{{topTitle.title}}</span>
            </div>
            <!-- <span :style="{'color':'#28287d','font-weight':'bold'}"
                v-if="showTitle">{{ title }}</span> -->
        </div>
    </router-link>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    showLogo: {
      type: Boolean,
      default: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    topTitle: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      type: process.env.VUE_APP_TYPE,
      title: process.env.VUE_APP_TITLE,
      logo: require('@/assets/images/safe.png')
    }
  },
  computed: {
    to() {
      let rtn = {}
      if (this.$store.state.settings.enableDashboard) {
        rtn.name = 'dashboard'
      }
      return rtn
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  position: fixed;
  z-index: 1000;
  top: 0;
  width: inherit;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: $g-sidebar-logo-height;
  text-align: center;
  overflow: hidden;
  text-decoration: none;
  &.is-link {
    cursor: pointer;
  }
  .logo {
    width: 30px;
    // height: 30px;
    & + span {
      margin-left: 10px;
    }
  }
  span {
    display: block;
    font-weight: bold;
    color: #fff;
    @include text-overflow;
  }
}
</style>
